module.exports = __webpack_public_path__ + "img/aanmelden-kleur-je-leven.png";